/* eslint-disable comma-dangle, quote-props, quotes */
export default {
  "link": [
    {
      "rel": "apple-touch-icon",
      "sizes": "120x120",
      "href": "/favicons/apple-touch-icon.png"
    },
    {
      "rel": "icon",
      "type": "image/png",
      "href": "/favicons/favicon-32x32.png",
      "sizes": "32x32"
    },
    {
      "rel": "icon",
      "type": "image/png",
      "href": "/favicons/favicon-16x16.png",
      "sizes": "16x16"
    },
    {
      "rel": "manifest",
      "href": "/favicons/manifest.json"
    },
    {
      "rel": "mask-icon",
      "href": "/favicons/safari-pinned-tab.svg",
      "color": "#d10a11"
    },
    {
      "rel": "shortcut icon",
      "href": "/favicons/favicon.ico"
    }
  ],
  "meta": [
    {
      "name": "msapplication-TileColor",
      "content": "#d10a11"
    },
    {
      "name": "msapplication-config",
      "content": "/favicons/browserconfig.xml"
    },
    {
      "name": "theme-color",
      "content": "#ffffff"
    }
  ]
}



// WEBPACK FOOTER //
// ./src/common/app/favicon.js